import React, { useState } from 'react';
import { Badge, Card, Table } from 'react-bootstrap';
import { Button } from 'primereact/button';
import { Sidebar } from 'primereact/sidebar';
import Edit_employee_leave from '../components/Edit_employee_leave';
import { Tooltip } from 'primereact/tooltip';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import config from '../config';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from "primereact/dialog";
const Approvedleave = ({ approvedLeaves, fetchLeaveRequests }) => {
    const [visibleRight, setVisibleRight] = useState(false);
    const [selectedsplitRequest, setSelectedsplitRequest] = useState(null);
    const { accessToken, userId, role } = useAuth();
    const [leaveBalances, setLeaveBalances] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const [selectedLeaveType, setSelectedLeaveType] = useState(null);
    const [errorMessage, setErrorMessage] = useState(''); // State to hold error message
    const [selectedRequest, setSelectedRequest] = useState(null);

    const [showRescindDialog, setShowRescindDialog] = useState(false);
    const [rescindComment, setRescindComment] = useState("");
    const [rescindRequest, setRescindRequest] = useState(null);
    const [rescindError, setRescindError] = useState("");


    const handleOpenRescindDialog = (request) => {
        setRescindRequest(request);
        setRescindComment("");
        setRescindError("");
        setShowRescindDialog(true);
    };

    const handleSidebarClose = () => {
        setVisibleRight(false);
        fetchLeaveRequests(); // Refresh leave requests after closing the sidebar
    };

    // Fetch leave balances for the selected user

    const fetchLeaveBalances = async (user_id) => {
        try {
            const response = await axios.get(
                `${config.apiBASEURL}/leaveRoutes/fetch-user-leave-balances/${user_id}`,
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                }
            );
            setLeaveBalances(response.data.data); // Set leave balances array
        } catch (error) {
            console.error('Error fetching leave balances:', error);
        }
    };
    const handleOpenDialog = (request) => {
        setSelectedRequest(request);
        fetchLeaveBalances(request.requestor.User_id);
        setShowDialog(true);
    };

    const handleSaveLeaveType = async () => {
        if (!selectedRequest || !selectedLeaveType) {
            setErrorMessage('Please select a leave type.');
            return;
        }

        try {
            const response = await axios.put(
                `${config.apiBASEURL}/leaveRoutes/update-leave-type`,
                {
                    leave_request_id: selectedRequest.Leave_request_id,
                    new_leave_type_id: selectedLeaveType.leave_type_id,
                },
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                }
            );

            // Check for status 200
            if (response.status === 200) {
                fetchLeaveRequests(); // Refresh leave requests
                setShowDialog(false); // Close dialog
                setErrorMessage(''); // Clear error message
            }
        } catch (error) {
            console.error('Error updating leave type:', error);
            // Extract the error message based on the API response structure
            if (error.response && error.response.data && error.response.data.error) {
                setErrorMessage(error.response.data.error);
            } else {
                setErrorMessage("An unexpected error occurred. Please try again.");
            }
        }
    };




    const handleRescindLeave = async () => {
        if (!rescindComment.trim()) {
            setRescindError("Please enter a comment.");
            return;
        }

        try {
            await axios.put(
                `${config.apiBASEURL}/leaveRoutes/rescind-leave`,
                {
                    Leave_request_id: rescindRequest.Leave_request_id,
                    Comment: rescindComment,
                    Approved_By: userId
                },
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                }
            );

            setShowRescindDialog(false);
            fetchLeaveRequests(); // Refresh leave list
        } catch (error) {
            console.error("Error rescinding leave:", error);
            setRescindError(error.response?.data?.message || "Failed to rescind leave");
        }
    };


    return (
        <>
            <Card className="shadow-0">
                <Table hover bordered size="sm" className="table-responsive">
                    <thead>
                        <tr>
                            <th style={{ width: '250px' }}>Name</th>
                            <th>Dates</th>
                            {/* <th style={{ width: '100px' }}>Duration</th> */}
                            <th style={{ width: '200px' }}>Reason</th>
                            <th style={{ width: '100px' }}>Issued On</th>
                            <th style={{ width: '100px' }}>Status</th>
                            <th style={{ width: '200px' }}>Comment</th>
                            <th style={{ width: '100px' }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(approvedLeaves) && approvedLeaves.length > 0 ? (
                            approvedLeaves.map((request) => {
                                const { requestor, leaveType, dates } = request;
                                const parsedDates = Array.isArray(dates)
                                    ? dates
                                    : JSON.parse(dates || '[]');

                                return (
                                    <tr key={request.Leave_request_id}>
                                        <td>

                                            <div className="d-flex align-items-center justify-content-start">
                                                <img
                                                    src={requestor.profileImage?.image_url ||
                                                        require('../assets/images/no_user.png')}
                                                    alt=""
                                                    style={{ width: '30px', height: '30px' }}
                                                    className="rounded-circle"
                                                />
                                                <div className="ms-3">
                                                    <p className="mb-0 text-dark">
                                                        <b>
                                                            {requestor.first_name} {requestor.last_name}
                                                        </b>
                                                    </p>
                                                    <p className="text-muted mb-0">
                                                        <b className="text-info">{request.Total_days} Days</b>
                                                    </p>
                                                </div>
                                            </div>

                                        </td>
                                        <td>
                                            <div>
                                                <p className="mb-2 text-primary fw-bold">
                                                    {leaveType?.name || 'N/A'}
                                                </p>
                                                <span className='d-block'>
                                                    {parsedDates.map((date, index) => (
                                                        <small key={index} className='alldateSpan'>
                                                            {new Date(date).toLocaleDateString("en-GB")}
                                                        </small>
                                                    ))}
                                                </span>
                                            </div>
                                        </td>
                                        {/* <td>{request.Total_days}</td> */}
                                        <td>
                                            <Tooltip target={`.reason-tooltip-${request.Leave_request_id}`}>
                                                <p style={{ fontWeight: '400', lineHeight: '1.5' }}>{request.reason}</p>
                                            </Tooltip>
                                            <p className={`mb-0 reason-tooltip-${request.Leave_request_id}`}>{request.reason}</p>
                                        </td>
                                        <td>
                                            {new Date(request.createdAt).toLocaleDateString("en-GB")}
                                        </td>
                                        <td>
                                            <span
                                                className={`badge ${request.Status === "Approved"
                                                    ? "bg-success"
                                                    : request.Status === "Pending"
                                                        ? "bg-warning"
                                                        : request.Status === "Rejected"
                                                            ? "bg-danger"
                                                            : "bg-secondary"
                                                    }`}
                                            >
                                                {request.Status}
                                            </span>
                                        </td>
                                        <td>
                                            <Tooltip target={`.comment-tooltip-${request.Leave_request_id}`}>
                                                <p style={{ fontWeight: '400', lineHeight: '1.5' }}>{request.Comment}</p>
                                            </Tooltip>
                                            <p className={`mb-0 comment-tooltip-${request.Leave_request_id}`}>{request.Comment}</p>
                                        </td>
                                        <td>
                                            {(role === 'Founder' || role === 'Admin' || role === 'SuperAdmin') && (
                                                <>

                                                    <Button
                                                        title="Edit Leave Type"
                                                        outlined
                                                        severity='info'
                                                        icon="pi pi-pencil"
                                                        onClick={() => handleOpenDialog(request)}
                                                        className='border-0'
                                                    />
                                                    <Button
                                                        title="Split"
                                                        icon="pi pi-arrow-right-arrow-left"
                                                        outlined
                                                        className='ms-2 border-0 p-0'
                                                        severity="help"
                                                        onClick={() => {
                                                            setSelectedsplitRequest(request); // Set the selected request data
                                                            setVisibleRight(true); // Open the sidebar
                                                        }}
                                                    />

                                                    <Button
                                                        title="Rescind Leave"
                                                        icon="pi pi-times"
                                                        outlined
                                                        severity="danger"
                                                        className="ms-2 border-0"
                                                        onClick={() => handleOpenRescindDialog(request)}
                                                    />
                                                </>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="7" className="text-center">
                                    No approved leave requests found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </Card>
            {/* Dialog for Editing Leave Type */}
            <Dialog
                visible={showDialog}
                header="Change Leave Type"
                style={{ width: '350px' }}
                modal
                onHide={() => setShowDialog(false)} // This ensures the dialog closes when you click outside or press "X".

                footer={
                    <div>
                        {errorMessage && (
                            <div className="text-danger d-flex text-start justify-content-start align-items-center">
                                {/* <i className="pi pi-exclamation-triangle me-2"></i> */}
                                <small>{errorMessage}</small>
                            </div>
                        )}

                    </div>
                }

            >
                <div>
                    <Dropdown
                        value={selectedLeaveType}
                        options={leaveBalances}
                        onChange={(e) => setSelectedLeaveType(e.value)}
                        optionLabel="name"
                        placeholder="Select Leave Type"
                    />
                    <div className="mt-3 text-end">
                        <Button
                            label="Save"
                            icon="pi pi-check"
                            onClick={handleSaveLeaveType}
                            className="border-0 py-2 px-3"
                            severity='success'
                        />
                    </div>
                </div>
            </Dialog>
            <Sidebar header="Split Leave Request" visible={visibleRight} position="right" style={{ width: '380px' }} onHide={handleSidebarClose}
                dismissable={false}
            >
                <Edit_employee_leave
                    requestData={selectedsplitRequest}
                    onSuccess={() => {
                        setVisibleRight(false); // Close sidebar on success
                        fetchLeaveRequests(); // Refresh leave requests
                    }}
                />
                {/* <Button title='Close' severity='danger' outlined className='border-0' icon='pi pi-times' onClick={() => setVisibleRight(false)} /> */}
            </Sidebar>


            <Dialog
                visible={showRescindDialog}
                header="Rescind Leave Request"
                style={{ width: "400px" }}
                modal
                onHide={() => setShowRescindDialog(false)}
                footer={
                    <div className="d-flex justify-content-end">
                        <Button
                            label="Cancel"
                            outlined
                            severity="secondary"
                            onClick={() => setShowRescindDialog(false)}
                            className="me-2 border-0"
                        />
                        <Button
                            label="Confirm Rescind"
                            icon="pi pi-check"
                            severity="danger"
                            className="border-0"
                            onClick={handleRescindLeave}
                        />
                    </div>
                }
            >
                <div>
                    <label className="form-label">Comment</label>
                    <textarea
                        className="form-control"
                        rows={3}
                        value={rescindComment}
                        onChange={(e) => setRescindComment(e.target.value)}
                        placeholder="Enter reason for rescinding"
                    />
                    {rescindError && (
                        <small className="text-danger">{rescindError}</small>
                    )}
                </div>
            </Dialog>



        </>
    );
};

export default Approvedleave;
